import {
  Button, Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Tooltip
} from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import Fade from "@material-ui/core/Fade";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import {
  alpha, createStyles,
  makeStyles, Theme, useTheme
} from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import HomeIcon from "@material-ui/icons/Home";
import InvertColorsIcon from "@material-ui/icons/InvertColors";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import MenuIcon from "@material-ui/icons/Menu";
import NotificationsNoneTwoToneIcon from "@material-ui/icons/NotificationsNoneTwoTone";
import AccessibilityNewIcon from '@mui/icons-material/AccessibilityNew';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import AddReactionIcon from '@mui/icons-material/AddReaction';
import AddTaskIcon from '@mui/icons-material/AddTask';
import AddToQueueIcon from '@mui/icons-material/AddToQueue';
import BugReportIcon from '@mui/icons-material/BugReport';
import CabinIcon from '@mui/icons-material/Cabin';
import ClosedCaptionIcon from '@mui/icons-material/ClosedCaption';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import LocalLibraryIcon from '@mui/icons-material/LocalLibrary';
import MedicalInformationIcon from '@mui/icons-material/MedicalInformation';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import WhereToVoteIcon from '@mui/icons-material/WhereToVote';
import TimelineIcon from '@mui/icons-material/Timeline';
import clsx from "clsx";
import React from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { useUser } from "../../../providers/user";
import { changePassword } from "../store/actions";
import AppsOutageIcon from '@mui/icons-material/AppsOutage';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
const drawerWidth = 240;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 0,
    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    appBarShift: {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    title: {
      flexGrow: 1,
      display: "none",
      [theme.breakpoints.up("sm")]: {
        display: "block",
      },
    },
    menuButton: {
      marginRight: 36,
    },
    hide: {
      display: "none",
    },
    drawer: {
      color: "#fff",
      width: drawerWidth,
      flexShrink: 0,
      whiteSpace: "nowrap",
    },
    drawerOpen: {
      width: drawerWidth,
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    drawerClose: {
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      overflowX: "hidden",
      width: theme.spacing(7) + 1,
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(9) + 1,
      },
    },
    toolbar: {
      display: "flex",
      alignItems: "left",
      justifyContent: "flex-start",
      backgroundColor: "#12145e",
      padding: theme.spacing(0, 1),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
    content: {
      width: "80%",
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    search: {
      position: "relative",
      borderRadius: theme.shape.borderRadius,
      backgroundColor: alpha(theme.palette.common.white, 0.15),
      "&:hover": {
        backgroundColor: alpha(theme.palette.common.white, 0.25),
      },
      marginLeft: 0,
      width: "100%",
      [theme.breakpoints.up("sm")]: {
        marginLeft: theme.spacing(1),
        width: "auto",
      },
    },
    searchIcon: {
      padding: theme.spacing(0, 2),
      height: "100%",
      position: "absolute",
      pointerEvents: "none",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    titleButtor: {
      flexGrow: 1,
      display: "none",
      [theme.breakpoints.up("sm")]: {
        display: "block",
      },
      color: "#fff",
    },
    dashbord: {
      color: "#fff",
      fontSize: "18px",
      fontWeight: "normal",
      padding: "20px 0px 10px 10px",
    },
    logedUser: {
      padding: "10px 0px 10px 20px",
      fontSize: "14px",
      align: "center",
      fontWeight: "bold",
    },
    inputRoot: {
      color: "inherit",
    },
    inputInput: {
      padding: theme.spacing(1, 1, 1, 0),
      // vertical padding + font size from searchIcon
      paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
      transition: theme.transitions.create("width"),
      width: "100%",
      [theme.breakpoints.up("sm")]: {
        width: "12ch",
        "&:focus": {
          width: "20ch",
        },
      },
    },
  })
);
interface Props {
}
const GenomicsResearchlabDashboardLeft: React.FC<Props> = () => {
  const dispatch = useDispatch();
  const user = useUser();
  const classes = useStyles();
  const theme = useTheme();
  /* Right Menu click */
  const [openRightMenu, setOpenRightMenu] = React.useState<boolean>(false);
  const [anchorEl, setAnchorEl] = React.useState();
  const handleClick = (event: any) => {
    setOpenRightMenu(true);
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setOpenRightMenu(false);
  };
  const [open, setOpen] = React.useState(false);
  const [open1, setOpen1] = React.useState(false);
  const [changePasswordModal, setchangePasswordModal] = React.useState(false);
  const [oldPassword, setOldPassword] = React.useState("");
  const [newPassword, setNewPassword] = React.useState("");
  const [confirmPassword, setConfirmPassword] = React.useState("");
  const [anchorElUpdate, setAnchorElUpdate] = React.useState(null);
  const id = open ? "transitions-popper" : undefined;

  const updatePassword = async () => {
    const body: any = {
      old_password: oldPassword,
      new_password: newPassword,
      confirm_password: confirmPassword,
    };
    await dispatch(changePassword(body));
    setchangePasswordModal(false);
  };

  const handleDrawerOpen = () => {
    setOpen1(true);
  };

  const handleDrawerClose = () => {
    setOpen1(false);
  };


  const handleUpdateDetails = (event: any) => {
    setAnchorElUpdate(anchorElUpdate ? null : event.currentTarget);
  };
  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open1,
        })}
      >
        <Toolbar style={{ backgroundColor: "#12145e" }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            className={clsx(classes.menuButton, {
              [classes.hide]: open1,
            })}
          >
            <MenuIcon />
          </IconButton>
          <Typography className={classes.title} variant="h6" noWrap>
            Redcliffe Genomics Research
          </Typography>
          <div>
            <Button
              variant="text"
              onClick={(e) => handleClick(e)}
              size="medium"
              endIcon={<KeyboardArrowDownIcon />}
              style={{ color: "#fff" }}
            >
              {user.profile?.fullname || user.profile?.username}
            </Button>
            <Menu
              id="fade-menu"
              open={openRightMenu}
              onClose={handleClose}
              TransitionComponent={Fade}
              anchorEl={anchorEl}
            >
              <MenuItem onClick={() => setchangePasswordModal(true)}>
                Change Password
              </MenuItem>
              <MenuItem onClick={user.logout}>Logout</MenuItem>
            </Menu>
            <IconButton onClick={handleUpdateDetails}>
              <NotificationsNoneTwoToneIcon
                style={{
                  color: "white",
                }}
                aria-describedby={id}
              />
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open1,
          [classes.drawerClose]: !open1,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open1,
            [classes.drawerClose]: !open1,
          }),
        }}
      >
        <Dialog
          open={changePasswordModal}
          onClose={() => setchangePasswordModal(false)}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Change Password</DialogTitle>
          <DialogContent>
            <TextField
              id="name"
              placeholder="Old Password"
              type="password"
              fullWidth
              style={{
                width: "100%",
                margin: "0.3rem auto",
                padding: "14px !important",
              }}
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
            />
            <TextField
              id="name"
              placeholder="New Password"
              type="password"
              fullWidth
              style={{
                width: "100%",
                margin: "0.3rem auto",
                padding: "14px !important",
              }}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
            <TextField
              id="name"
              placeholder="Confirm Password"
              type="password"
              fullWidth
              style={{
                width: "100%",
                margin: "0.3rem auto",
                padding: "14px !important",
              }}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => updatePassword()} color="primary">
              Update
            </Button>
            <Button
              onClick={() => setchangePasswordModal(false)}
              color="primary"
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
        <div className={classes.toolbar}>
          <span className={classes.dashbord}>Dashboard</span>
          <IconButton onClick={handleDrawerClose} style={{ color: "#fff" }}>
            {theme.direction === "rtl" ? (
              <ChevronRightIcon />
            ) : (
              <ChevronLeftIcon />
            )}
          </IconButton>
        </div>
        <Divider />
        {user.profile?.usergroup === "GenomicsResearch" && <>
          <List>
            <Link to="/dashboard/gnre">
              <ListItem button>
                <Tooltip title="Home" arrow>
                  <ListItemIcon>
                    <HomeIcon style={{ color: "#12145e" }} />
                  </ListItemIcon>
                </Tooltip>
                <ListItemText primary="Home" />
              </ListItem>
            </Link>
          </List>
          {/* <List>
           <Link to="/dashboard/gnre/browseData">
             <ListItem button>
               <Tooltip title="BrowseData" arrow>
                 <ListItemIcon>
                   <AssessmentIcon style={{ color: "#12145e" }} />
                 </ListItemIcon>
               </Tooltip>
               <ListItemText primary="Browse Data" />
             </ListItem>
           </Link>
         </List> */}
        </>}
        {user.profile?.usergroup === "GenomicsResearchClient" && <>
          <List>
            <Link to="/dashboard/gnre/samples_tracker">
              <ListItem button>
                <Tooltip title="Profile" arrow>
                  <ListItemIcon>
                    <TimelineIcon style={{ color: "#12145e" }} />
                  </ListItemIcon>
                </Tooltip>
                <ListItemText primary="Profile" />
              </ListItem>
            </Link>
          </List>
          <List>
            <Link to="/dashboard/gnre/samples_tracker_count">
              <ListItem button>
                <Tooltip title="Sample Count" arrow>
                  <ListItemIcon>
                    <TrackChangesIcon style={{ color: "#12145e" }} />
                  </ListItemIcon>
                </Tooltip>
                <ListItemText primary="Sample Count" />
              </ListItem>
            </Link>
          </List>
        </>}
        {(user.profile?.usergroup === "GenomicsResearchLab" || user.profile?.usergroup === "GenomicsResearchUser") &&
          <List>
            <Link to="">
              <ListItem button>
                <Tooltip title="Home" arrow>
                  <ListItemIcon>
                    <HomeIcon style={{ color: "#12145e" }} />
                  </ListItemIcon>
                </Tooltip>
                <ListItemText primary="Home" />
              </ListItem>
            </Link>
          </List>
        }
        {user.hasPermission("gr:samples") &&
          <List>
            <Link to="/dashboard/gnre/samples">
              <ListItem button>
                <Tooltip title="Sample Accessioning" arrow>
                  <ListItemIcon>
                    <AddTaskIcon style={{ color: "#12145e" }} />
                  </ListItemIcon>
                </Tooltip>
                <ListItemText primary="Sample Accessioning" />
              </ListItem>
            </Link>
          </List>
        }
        {user.hasPermission("gr:projects") && <List>
          <Link to="/dashboard/gnre/projects/data">
            <ListItem button>
              <Tooltip title="Create Project" arrow>
                <ListItemIcon>
                  <InvertColorsIcon style={{ color: "#12145e" }} />
                </ListItemIcon>
              </Tooltip>
              <ListItemText primary="Projects" />
            </ListItem>
          </Link>
        </List>
        }
        {/* {user.hasPermission("gr:samples") &&
          <List>
            <Link to="/dashboard/gnre/samples_tracker">
              <ListItem button>
                <Tooltip title="Sample Tracker" arrow>
                  <ListItemIcon>
                    <TimelineIcon style={{ color: "#12145e" }} />
                  </ListItemIcon>
                </Tooltip>
                <ListItemText primary="Sample Tracker" />
              </ListItem>
            </Link>
          </List>
        } */}
        {/* <List>
          <Link to="/dashboard/gnre/failedSamples/">
            <ListItem button>
              <Tooltip title="Failed Samples" arrow>
                <ListItemIcon>
                  <SmsFailedIcon style={{ color: "#12145e" }} />
                </ListItemIcon>
              </Tooltip>
              <ListItemText primary="Failed Samples" />
            </ListItem>
          </Link>
        </List> */}
        {user.hasPermission("gr:clients") && <>
          <List>
            <Link to="/dashboard/gnre/Client">
              <ListItem button>
                <Tooltip title="Client Creation" arrow>
                  <ListItemIcon>
                    <AccessibilityNewIcon style={{ color: "#12145e" }} />
                  </ListItemIcon>
                </Tooltip>
                <ListItemText primary="Client Creation" />
              </ListItem>
            </Link>
          </List>
          <List>
            <Link to="/dashboard/gnre/institute/create">
              <ListItem button>
                <Tooltip title="Institute Creation" arrow>
                  <ListItemIcon>
                    <CabinIcon style={{ color: "#12145e" }} />
                  </ListItemIcon>
                </Tooltip>
                <ListItemText primary="Institute Creation" />
              </ListItem>
            </Link>
          </List>
          <List>
            <Link to="/dashboard/gnre/dealer/create">
              <ListItem button>
                <Tooltip title="Dealer Creation" arrow>
                  <ListItemIcon>
                    <AddReactionIcon style={{ color: "#12145e" }} />
                  </ListItemIcon>
                </Tooltip>
                <ListItemText primary="Dealer Creation" />
              </ListItem>
            </Link>
            {/* <Link to="/dashboard/gnre/genom_itr">
              <ListItem button>
                <Tooltip title="Genom IT" arrow>
                  <ListItemIcon>
                    <AppsOutageIcon style={{ color: "#12145e" }} />
                  </ListItemIcon>
                </Tooltip>
                <ListItemText primary="Genom IT" />
              </ListItem>
            </Link> */}
          </List>
        </>}
        {/* <List>
          <Link to="/dashboard/gnrelab/Project/data">
            <ListItem button>
              <Tooltip title="Project Data" arrow>
                <ListItemIcon>
                  <ChangeHistoryIcon style={{ color: "#12145e" }} />
                </ListItemIcon>
              </Tooltip>
              <ListItemText primary="Projects Data" />
            </ListItem>
          </Link>
        </List> */}
        {user.hasPermission("gr:project-samples") && <List>
          <Link to="/dashboard/gnrelab/project-samples">
            <ListItem button>
              <Tooltip title="Sample Creation" arrow>
                <ListItemIcon>
                  <HealthAndSafetyIcon style={{ color: "#12145e" }} />
                </ListItemIcon>
              </Tooltip>
              <ListItemText primary="Sample Registrations" />
            </ListItem>
          </Link>
        </List>
        }
        {user.hasPermission("gr:storage") && <List>
          <Link to="/dashboard/gnrelab/sample/storage">
            <ListItem button>
              <Tooltip title="Sample Storage" arrow>
                <ListItemIcon>
                  <WarehouseIcon style={{ color: "#12145e" }} />
                </ListItemIcon>
              </Tooltip>
              <ListItemText primary="Sample Storage" />
            </ListItem>
          </Link>
        </List>
        }
        {user.hasPermission("gr:qc") &&
          <List>
            <Link to="/dashboard/gnrelab/sample/qc">
              <ListItem button>
                <Tooltip title="Sample QC" arrow>
                  <ListItemIcon>
                    <BugReportIcon style={{ color: "#12145e" }} />
                  </ListItemIcon>
                </Tooltip>
                <ListItemText primary="Sample QC" />
              </ListItem>
            </Link>
          </List>
        }
        {user.hasPermission("gr:library") &&
          <List>
            <Link to="/dashboard/gnrelab/library">
              <ListItem button>
                <Tooltip title="Library" arrow>
                  <ListItemIcon>
                    <LocalLibraryIcon style={{ color: "#12145e" }} />
                  </ListItemIcon>
                </Tooltip>
                <ListItemText primary="Library" />
              </ListItem>
            </Link>
          </List>
        }
        {user.hasPermission("gr:sequencing") &&
          <List>
            <Link to="/dashboard/gnrelab/Sequencing">
              <ListItem button>
                <Tooltip title="Sequencing" arrow>
                  <ListItemIcon>
                    <AddToQueueIcon style={{ color: "#12145e" }} />
                  </ListItemIcon>
                </Tooltip>
                <ListItemText primary="Sequencing" />
              </ListItem>
            </Link>
          </List>
        }
        {user.hasPermission("gr:runvalidation") &&
          <List>
            <Link to="/dashboard/gnrelab/runvalidation">
              <ListItem button>
                <Tooltip title="Run_Plan Validation" arrow>
                  <ListItemIcon>
                    <FactCheckIcon style={{ color: "#12145e" }} />
                  </ListItemIcon>
                </Tooltip>
                <ListItemText primary="Run_Plan Validation" />
              </ListItem>
            </Link>
          </List>
        }
        {user.hasPermission("gr:dataqc") &&
          <List>
            <Link to="/dashboard/gnrelab/dataqc">
              <ListItem button>
                <Tooltip title="Data Status" arrow>
                  <ListItemIcon>
                    <WhereToVoteIcon style={{ color: "#12145e" }} />
                  </ListItemIcon>
                </Tooltip>
                <ListItemText primary="Data Status" />
              </ListItem>
            </Link>
          </List>
        }
        {user.hasPermission("gr:bioinformatics") && <List>
          <Link to="/dashboard/gnrelab/bioinform">
            <ListItem button>
              <Tooltip title="BioInformatics" arrow>
                <ListItemIcon>
                  <MedicalInformationIcon style={{ color: "#12145e" }} />
                </ListItemIcon>
              </Tooltip>
              <ListItemText primary="Bio Informatics" />
            </ListItem>
          </Link>
        </List>}
        {user.hasPermission("gr:deliverables") && <List>
          <Link to="/dashboard/gnrelab/final_reports">
            <ListItem button>
              <Tooltip title="Deliverable Section" arrow>
                <ListItemIcon>
                  <AcUnitIcon style={{ color: "#12145e" }} />
                </ListItemIcon>
              </Tooltip>
              <ListItemText primary="Deliverable Section" />
            </ListItem>
          </Link>
        </List>}
        {user.hasPermission("gr:billing") &&
          <List>
            <Link to="/dashboard/gnrelab/ProjectCloser">
              <ListItem button>
                <Tooltip title="Billing" arrow>
                  <ListItemIcon>
                    <ClosedCaptionIcon style={{ color: "#12145e" }} />
                  </ListItemIcon>
                </Tooltip>
                <ListItemText primary="Billing" />
              </ListItem>
            </Link>
          </List>
        }
        <Divider />
        <List>
          <ListItem button onClick={user.logout}>
            <Tooltip title="Logout" arrow>
              <ListItemIcon>
                <ExitToAppIcon style={{ color: "#12145e" }} />
              </ListItemIcon>
            </Tooltip>
            <ListItemText primary="Logout" />
          </ListItem>
        </List>
      </Drawer>
    </div>
  );
};

export default GenomicsResearchlabDashboardLeft;
